import { render, staticRenderFns } from "./VBar.vue?vue&type=template&id=1ba1b150&scoped=true&"
import script from "./VBar.vue?vue&type=script&lang=ts&"
export * from "./VBar.vue?vue&type=script&lang=ts&"
import style0 from "./VBar.vue?vue&type=style&index=0&id=1ba1b150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba1b150",
  null
  
)

export default component.exports